import React, { createContext, useContext, useCallback } from 'react';
import { templateAPI, apiUtils } from '../service/api';

const TemplateContext = createContext();

export const TemplateProvider = ({ children }) => {

  const fetchTemplates = useCallback(async (params = {}) => {
    try {
      const response = await templateAPI.getTemplatesDisplay(params);
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, message: response.data.message || 'टेम्पलेट्स लोड करने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { success: false, message: errorData.message };
    }
  }, []);

  const fetchGroups = useCallback(async () => {
    try {
      const response = await templateAPI.getDesignGroups();
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, message: response.data.message || 'ग्रुप्स लोड करने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { success: false, message: errorData.message };
    }
  }, []);

  const fetchTemplateDetails = useCallback(async (templateId) => {
    try {
      const response = await templateAPI.getTemplateDetails(templateId);
      console.log("template details in context", response);
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, message: response.data.message || 'टेम्पलेट डिटेल्स लोड करने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { 
        success: false, 
        message: errorData.message,
        status: errorData.status,
        redirectUrl: errorData.data?.redirectUrl 
      };
    }
  }, []);

  // 🔴 NEW: Design Entry create karne ka function
  const createDesignEntry = useCallback(async (templateId) => {
    try {
      // Dhyan dein: Ye ek POST request hai
      const response = await templateAPI.createDesignEntry(templateId);
      console.log("entry created response:", response);
      
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, message: response.data.message || 'डिज़ाइन एंट्री बनाने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { 
        success: false, 
        message: errorData.message,
        status: errorData.status,
        redirectUrl: errorData.data?.redirectUrl 
      };
    }
  }, []);

  const updateDesignEntry = useCallback(async (entryId, payload) => {
    try {
      const response = await templateAPI.updateDesignEntry(entryId, payload);
      // Backend status: "success" de raha hai
      if (response.data.status === 'success' || response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, message: response.data.message || 'डिज़ाइन सेव करने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { success: false, message: errorData.message, status: errorData.status, redirectUrl: errorData.data?.redirectUrl };
    }
  }, []);

  const fetchDownloads = useCallback(async (params = { page: 1, limit: 25 }) => {
    try {
      const response = await templateAPI.getDownloads(params);
      
      // Backend status: "success" de raha hai
      if (response.data.status === 'success' || response.data.success) {
        return { 
          success: true, 
          data: response.data.data 
        };
      } else {
        return { success: false, message: response.data.message || 'डाउनलोड्स लोड करने में विफल' };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      return { 
        success: false, 
        message: errorData.message, 
        status: errorData.status, 
        redirectUrl: errorData.data?.redirectUrl 
      };
    }
  }, []);

  const value = {
    fetchTemplates,
    fetchGroups,
    fetchTemplateDetails,
    createDesignEntry,
    updateDesignEntry,
    fetchDownloads
  };

  return (
    <TemplateContext.Provider value={value}>
      {children}
    </TemplateContext.Provider>
  );
};

export const useTemplate = () => {
  const context = useContext(TemplateContext);
  if (!context) {
    throw new Error('useTemplate must be used within a TemplateProvider');
  }
  return context;
};

export default TemplateContext;